import { type ReactNode } from 'react'
import useAuthStore from '@/stores/useAuthStore'
import usePermissionsStore from '@/stores/usePermissionsStore'
import ErrorPage from '@/components/ErrorBoundary/ErrorPage'
import { OPERATIONS_DEPARTMENT_IDS } from '../constants'

// Mirrors the sidebar gate. Only a convenience: servicemgmt enforces the real
// one (group /Admin) and a 403 renders in the table.
const OperationsAccessGuard = ({ children }: { children: ReactNode }) => {
    const isAdmin = usePermissionsStore((state) => state.isAdmin)
    const departmentId = useAuthStore((state) => state.employee?.department_id)
    const allowed =
        isAdmin ||
        (departmentId !== undefined &&
            OPERATIONS_DEPARTMENT_IDS.some(
                (allowedDepartmentId) => allowedDepartmentId === departmentId
            ))

    return allowed ? children : <ErrorPage status={403} />
}

export default OperationsAccessGuard
